import React from 'react';
import spinnerImage from '../../assets/img/spinner-loader.svg'

const Spinner = ({width}) => {
    return <img src={spinnerImage} width={width} alt="Spinner"  />;
};
Spinner.defaultProps = {
    width: 35
};
export default Spinner;